/**
* Kana validation
*/

const orderKana = () => {
  const inputFields = document.querySelectorAll(".kana-only");
  const submitBtn = document.querySelector('.js-order-submit-btn')
  const errorMsg = "全角カタカナのみでご入力ください。";

  if (!submitBtn) return;
  submitBtn.addEventListener("click", (e) => {
    inputFields.forEach(inputField => {
      const input:any = inputField.querySelector('input[type="text"]');
      const error = inputField.querySelector('.form__error');
      if (!input || !error) return;
      if(input.value == "") {
        error.classList.add("show");
        error.innerHTML = errorMsg
      }
    })
  })
  
  const regex = /^[ァ-ンー\s]+$/;
  inputFields.forEach(inputField => {
    const input:any = inputField.querySelector('input[type="text"]');
    const error = inputField.querySelector('.form__error');
    if (!input || !error) return;
    input.addEventListener("input", () => {
      //@ts-ignore
      if (!regex.test(input.value)) {
        error.classList.add("show");
        error.innerHTML = errorMsg

        if(input.value == "") {
          error.innerHTML = errorMsg
        }
      }
      else {
        error.classList.remove("show");
      }
    })
  })
}

export default orderKana
